import React from 'react';


interface AnimatedCheckboxProps {
  isChecked: boolean;
  onChange: (e:any) => void; // Event handler with no parameters
}

const AnimatedCheckbox: React.FC<AnimatedCheckboxProps> = ({ isChecked, onChange }) => {
  return (
    <div className="relative inline-flex items-center">
      <input
        type="checkbox"
        checked={isChecked}
        onChange={onChange}
        className="opacity-0 absolute w-full h-full cursor-pointer"
      />
      <svg
        viewBox="0 0 35.6 35.6"
        className="h-6 w-6 transition-all duration-300 ease-in-out"
      >
        {/* Background circle */}
        <circle
          cx="17.8"
          cy="17.8"
          r="17.8"
          className={`transition-colors duration-300 ease-in-out ${
            isChecked ? 'fill-primary-600' : 'fill-gray-300'
          }`}
        ></circle>

        {/* Animated stroke circle */}
        <circle
          cx="17.8"
          cy="17.8"
          r="14.37"
          className="fill-none stroke-white stroke-[2px] transition-all duration-300 ease-in-out"
          style={{
            strokeDasharray: 100,
            strokeDashoffset: isChecked ? 0 : 100,
          }}
        ></circle>

        {/* Check mark */}
        <polyline
          points="11.78 18.12 15.55 22.23 25.17 12.87"
          className="fill-none stroke-white stroke-[2px] stroke-linecap-round stroke-linejoin-round transition-all duration-300 ease-in-out"
          style={{
            strokeDasharray: 22,
            strokeDashoffset: isChecked ? 0 : 22,
          }}
        ></polyline>
      </svg>
    </div>
  );
};

export default AnimatedCheckbox;